import { render } from "./TerritoriesEdit.vue?vue&type=template&id=03cc1398&scoped=true"
import script from "./TerritoriesEdit.vue?vue&type=script&lang=js"
export * from "./TerritoriesEdit.vue?vue&type=script&lang=js"

import "./TerritoriesEdit.vue?vue&type=style&index=0&id=03cc1398&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cc1398"]])

export default __exports__